const apiUrls = ['https://www.swavlambancard.gov.in', 'https://swavlambancard.gov.in'];
const apiUrl = (apiUrls.includes(window.location.origin)) ? apiUrls[apiUrls.indexOf(window.location.origin)] : 'https://www.swavlambancard.gov.in';

export const environment = {
  production: true,
  app: 'UDID',
  version: 1.0,
  security: {
    key: 'bJG/tDlHg7oV41Mgx5+ZV62t6WWUMGMMd1v1z07YgYI=',
  },
  auth: {
    expires: (2 * 60 * 60 * 1000), // 2 hours in milliseconds
    key: 'UDID.AUTH',
    loginUrl: '/login',
    redirectUrl: '/dashboard/my-account',
    redirectUpdateEmail: '/dashboard/update-email-id',
    redirectUpdateMobile: '/dashboard/update-mobile-no',
    logoutUrl: '/',
  },
  depatmentlogin: {
    
   //redirectadminUrl: 'https://udidrewamp.php-staging.com/admin',
   redirectadminUrl: 'https://swavlambancard.gov.in/admin',

   // redirectadminUrl: 'https://www.swavlambancard.gov.in/admin',
    //redirectadminUrl: 'http://10.246.120.186/admin',
  },
  api: {
    // url: 'https://udidrewamp.php-staging.com/api/rest', // Server stagging
    // ekycUrls: 'https://udidrewamp.php-staging.com/api', // Same or different if needed

    url: apiUrl + '/api/rest', // server live   
    ekycUrls: apiUrl + '/api', // Same or different if needed   
    headers: {},
    timeout: 30000,
  },
  jsencrypt: {
    PUB_KEY: `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCn+gSMOvb+6oi2eWqmxlt/qoq4
3S2j7yXrLhIhtS02NPE+t14ZAQxMiJd5YPKps5ZcT2JhIdTv75ZPFmnj2+E0MhL2
XkCfkW6LEg4xVMr8TeV5cyVtRRjd8XkL+awA8niJKNYIJk8y/3112cT7TnrkB6Ct
4LHrrn2FG2Y9nVn8hQIDAQAB
-----END PUBLIC KEY-----`,
    PRIV_KEY: `-----BEGIN RSA PRIVATE KEY-----
MIICXAIBAAKBgQCn+gSMOvb+6oi2eWqmxlt/qoq43S2j7yXrLhIhtS02NPE+t14Z
AQxMiJd5YPKps5ZcT2JhIdTv75ZPFmnj2+E0MhL2XkCfkW6LEg4xVMr8TeV5cyVt
RRjd8XkL+awA8niJKNYIJk8y/3112cT7TnrkB6Ct4LHrrn2FG2Y9nVn8hQIDAQAB
AoGAXK0GYVAPAinn77UhcI4z4UX4b3IoQjApnY23lz1cinG/QDjvA6CeZoNd/yvL
9nEM3jU2NBz0XMS1C0F0frDLmJlZu3ko1EkPdN19bsDFKhNduOMugtT6s4w8WrrJ
XonnDQClddC+XNieuY2tF7d8+RK4fjvailbzrMaZZN+xKikCQQDc0PKsXCXhAwDf
1a+fzBdj+6mDBafe5p32pgXjCsBYzLk3A3UHsNPb3dQsXEmMLKQSGAe1w8W32Ugt
bst5nuGHAkEAwr3A5T+6D8aeMpnXX8CrOMlQJqxICy26p/Iyiv8nD4dCO5RAv76w
FdlN504QRf1Oj3FVuMtpifZ+7X+DhTykkwJAdz9fzjT1P86fakG71lAhUZ1Wrasg
PP/NzqVaCIKF3W6xl0QGr2CPCO2C53HvRgPVlu/jOgW/gMmWcPKkb8mdgQJBAI2N
SioY8VDISXN0eaXDMXIceqMxtUhS3At5tB1uq+DQq2cNMydtHycyhjrsdk25eyIu
+mVRjgxXXRmbB2mQk/sCQD1JWmiBihJkMB7ujbWDdrmsXe3RT6vSQCVmtVF/u5iF
t4FbIesVNmw1pOMe5v48E+utJ1ecOFGBWtcB395zmRU=
-----END RSA PRIVATE KEY-----`
  }
};
